import { themeConfig } from '@gap/shared/theme'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import CircularProgress from '@mui/material/CircularProgress'
import { observer } from 'mobx-react-lite'
import XeroXpmConnect from 'features/gap-components/xero-xpm-connect/XeroXpmConnect'
import { useXpmConnectionStore } from 'features/gap-components/xero-xpm-connect/XpmConnectionStore'

export default observer(function CreateClientModalXeroTab() {
   const xpmConnectionStore = useXpmConnectionStore()

   return <Box>
      {xpmConnectionStore.isSyncing && <Box sx={{
         display: 'flex',
         alignItems: 'center',
         gap: 1.5,
         p: 1.5,
         mb: 2,
         borderRadius: '8px',
         backgroundColor: themeConfig.primary[100],
         border: `1px solid ${themeConfig.primary[200]}`,
      }}>
         <CircularProgress size={16} />
         <Typography variant="body2" sx={{ color: themeConfig.primary[700] }}>
            Syncing clients from XPM… this can take a couple of minutes.
         </Typography>
      </Box>}

      <XeroXpmConnect showSyncAction />
      {!xpmConnectionStore.xeroAuthorised && <Box sx={{ mt: 1 }}>
         <Typography variant="caption" sx={{ color: themeConfig.primary[400] }}>
            To sync your clients, you'll be taken directly to XPM to establish a connection. You can also set this up later or manage your connection at any time from within your org settings.
         </Typography>
      </Box>}
   </Box>
})
